import {
	Interval,
	Duration,
} from "luxon";

export const pad = (v) => {
	const s = v.toString();
	return s.length < 2 ? `0${s}` : s;
};

export const seconds = (start, end, format) => {
	if (!start || !end) {
		return null;
	}

	const v = Math.round(Interval.fromDateTimes(start, end).length("seconds"));

	if (v < 0) {
		return "";
	}

	if (!format) {
		return v;
	}

	const m = Math.round(10 * v / 60) / 10;
	const h = Math.round(10 * m / 60) / 10;
	const d = Math.round(10 * m / 24) / 10;

	if (d > 1) {
		return format.replace("#", `${d} d`);
	}
	if (h > 1) {
		return format.replace("#", `${h} h`);
	}
	if (m > 1) {
		return format.replace("#", `${m} m`);
	}
	return format.replace("#", `${v} s`);
};

export const msToHM = (milliseconds) => {
	if (!milliseconds) {
		return null;
	}

	const dur = Duration.fromMillis(milliseconds).shiftTo("hours", "minutes");

	return `${pad(dur.hours)} H : ${pad(dur.minutes)} M`;
};
